import { IClientConfig } from '@front/interfaces/client-config.interface';
import { MMOModelUnitType } from '@shared';
import { defaultConfig } from './default.config';

export const nestleApConfig: IClientConfig = {
  ...defaultConfig,
  name: 'Nestlé',
  logo: 'assets/images/logo-nestle.svg',
  platformName: 'A&P 360 Platform',
  platformLogo: 'assets/images/ap_platform_nestle_logo.svg',
  moduleAccess: {
    investment: false,
    modelTypeSwitch: true,
    examples: false,
    gapAnalysis: false,
    displayAvm: true,
    configurationAsClient: false,
    digitalFocus: false,
    effectiveness: true,
    channelPerformance: false,
    scenarios: true
  },
  wording: {
    ...defaultConfig.wording,
    profit: 'Profit',
    roi: 'ROA&P'
  },
  modelUnitTypes: [MMOModelUnitType.turnover, MMOModelUnitType.volume, MMOModelUnitType.profit],
  modelTypeHideRoi: {
    [MMOModelUnitType.volume]: true
  },
  roiPerKpi: {
    [MMOModelUnitType.turnover]: 'ROA&P',
    [MMOModelUnitType.volume]: 'ROA&P',
    [MMOModelUnitType.profit]: 'ROA&P'
  },
  aggregationWording: ['Category', 'Macro Lever', 'Brand', 'Product'],
  variableUnits: ['EUR', 'GBP', 'JPY', 'USD', 'Tonnes']
};
